/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ShellSvgKey {
  static readonly MENU = 'shell/svg/menu';
  static readonly APPS = 'shell/svg/apps';
  static readonly ACCOUNT = 'shell/svg/account';
}
